<template>
<div class="chapter">
<div class="inner_page">
<p class="C268"><strong><a id="page_v">Contents</a></strong></p><a id="page_v">
</a><p class="C259"><a id="page_v"></a><a href="#/xhtml/04_Preface#page_vii">Preface</a></p>
<p class="C270"><a href="#/xhtml/05_1__Intro#page_1">1. Introduction: In Search of Freaks</a></p>
<p class="C271"><strong><a href="#/xhtml/06_I__Freak#page_23">I. Freak Show: The Institution</a></strong></p>
<p class="C270"><a href="#/xhtml/07_2__From#page_25">2. From Tavern to Madison Square Garden: A Chronicle of the Freak Show in America</a></p>
<p class="C270"><span href="#/xhtml/08_3__Step#page_69" title="Link target outside of Sample">3. Step Right Up: The World of Popular Amusement</span></p>
<p class="C270"><span href="#/xhtml/09_4__Exoti#page_94" title="Link target outside of Sample">4. Exotic and Aggrandized: Modes of Presenting Freaks</span></p>
<p class="C271"><strong><span href="#/xhtml/10_II__Prof#page_117" title="Link target outside of Sample">II. Profiles of Presentation</span></strong></p>
<p class="C270"><span href="#/xhtml/11_5__The_E#page_119" title="Link target outside of Sample">5. The Exhibition of People We Now Call Mentally Retarded</span></p>
<p class="C270"><span href="#/xhtml/12_6__Illus#page_147" title="Link target outside of Sample">6. Illusions of Grandeur</span></p>
<p class="C270"><span href="#/xhtml/13_7__Canni#page_176" title="Link target outside of Sample">7. Cannibals and Savages</span></p>
<p class="C270"><span href="#/xhtml/14_8__Respe#page_200" title="Link target outside of Sample">8. Respectable Freaks</span></p>
<p class="C270"><span href="#/xhtml/15_9__Self_#page_234" title="Link target outside of Sample">9. Self-Made Freaks</span></p>
<p class="C270"><span href="#/xhtml/16_10__Conc#page_267" title="Link target outside of Sample">10. Conclusion: Freak Encounter</span></p>
<p class="C271"><span href="#/xhtml/17_List_of#page_283" title="Link target outside of Sample">List of Abbreviations</span></p>
<p class="C270"><span href="#/xhtml/18_Notes#page_285" title="Link target outside of Sample">Notes</span></p>
<p class="C270"><span href="#/xhtml/19_Referenc#page_301" title="Link target outside of Sample">References</span></p>
<p class="C270"><span href="#/xhtml/20_Index#page_315" title="Link target outside of Sample">Index</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 03_Contents.vue?6485112c